import React from 'react';
import { Spacer } from '@cleartrip/bento';

import { List } from 'components/travelsafe';
import { Target } from 'components/composite';

function UsefulLinks({ links }) {
	return (
		<>
			<Spacer className='pt-5' />
			{links.map((item) => (
				<>
					<List.Title>{item.title}</List.Title>
					<Spacer className='pt-2' />
					{item.link &&
						item.link.map((link, linkIdx) => (
							<div className="pb-2--xs"> 
								<Target href={link} key={linkIdx} blank className='fs-4'>
									{link}
								</Target>
							</div>
						))}
					<Spacer className='pt-5 pt-3--xs' />
				</>
			))}
		</>
	);
}

export default UsefulLinks;
